import React from 'react';
import _ from 'lodash';
import { observer } from 'mobx-react';
import { styled } from '@this/constants/themes';
import A from '@this/shared/atoms/a';

import SelectTravelersBlock from '@this/shared/search/search_notify_members_block/select_travelers_block/select_travelers_block';
import type User from '@this/src/domain/user/user2';

interface Props {
  applicant?: User;
  users: (User | undefined)[];
  onAdd: (e: React.MouseEvent<HTMLElement>) => void;
  onSelect: (i: number, traveler: User, type: string) => void;
  onRemove: (e: React.MouseEvent<HTMLElement>, i: number) => void;
}

const NotifiedUserSelectorTemplate: React.FC<Props> = ({ applicant, users, onAdd, onSelect, onRemove }) => (
  <div data-testid="reserve-confirm-input-mail-notification-selectable-user-root">
    {users.map((user: User | undefined, i: number) => (
      <NotifiedUserBox key={i} data-testid={`reserve-confirm-input-mail-notification-selectable-user-row-${i}`}>
        <TravelerFromMember>
          <div data-testid={`reserve-confirm-input-mail-notification-selectable-user-selector-${i}`}>
            <SelectTravelersBlock
              user={applicant}
              traveler={user}
              index={i}
              onSelect={onSelect}
              excludeUserIds={[applicant?.id, ...users.map(u => u?.id)].filter(id => id !== undefined)}
            />
          </div>
        </TravelerFromMember>
        <NotifiedUserRemove onClick={e => onRemove(e, i)}>x</NotifiedUserRemove>
      </NotifiedUserBox>
    ))}
    <A data-testid="reserve-confirm-input-mail-notification-selectable-user-add" onClick={e => onAdd(e)}>
      出張内容を確認するユーザを追加する
    </A>
  </div>
);

const NotifiedUserBox = styled.div`
  display: flex;
  margin: 0 0 10px 0px;
`;

const NotifiedUserRemove = styled(A)`
  margin: auto 10px;
`;

const TravelerFromMember = styled.div`
  justify-content: space-between;
  flex-grow: 9999;
  min-width: 0;

  .reserve-confirm__traveler__label-name,
  .reserve-confirm__traveler__label-birthday {
    line-height: 26px;
  }
`;

export default observer(NotifiedUserSelectorTemplate);
